<template>
  <div>
    <v-searchHead :type="headType.searchHead" :keywords="$route.query.keyword"></v-searchHead>
    <div v-if="isReload && !findLikeWord" class="search-body">
      <div class="hotword-title">
        <span>热门搜索</span>
      </div>
      <div class="hotword-body">
        <button v-for="hot in hotwords" @click="search(hot)">{{hot}}</button>
      </div>
      <div class="history-title">
        <span>搜索历史</span>
      </div>
      <div class="history-body">
        <button v-for="h in histories" @click="search(h)">{{h}}</button>
      </div>
      <div class="clear-history" @click="clearHistory()">
        <span>清空搜索历史</span>
      </div>
      <div class="find-quan">
        <img :src="require('../../static/img/H5-find-quan.png')"/>
      </div>
    </div>
    <div class="like-word" v-if="isReload && findLikeWord">
      <div class="like-word-item" v-for="k in likeWords" @click="search(k)" v-html="showK(k)">
        <span>
          {{showK(k)}}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
  import SearchHead from './taoke/SearchHeader.vue';
  export default{
    name:'Search',
    data(){
      return{
        hotwords:[],
        histories:[],
        isReload:false,
        findLikeWord:false,
        keyword:'',
        likeWords:[],
        jsonp:require('jsonp')
      }
    },
    components:{
      'v-searchHead':SearchHead
    },
    created(){
      this.public.keyParam='';
      let seft = this;
      this.http.get(this.https.getHotWord).then(function(response){
        seft.hotwords = response.data.data;
        seft.isReload = true;
      }).catch(function(error){
        console.error(error);
      });
      this.histories =  window.localStorage.getItem("history")?JSON.parse(window.localStorage.getItem("history")):[];
    },
    mounted(){
      let uid = this.$route.query.uid;
      if(uid){
        this.setCookie("uid",uid,365);
      }
      let unionId = this.$route.query.unionId;
      if(unionId){
        this.setCookie("unionId",unionId,365);
      }
      let seft = this;
      this.watcher.$on('getlikeword',function(key){
        seft.keyword = key;
        seft.getLikeWord();
      });
      let actNow = this.$route.query.actNow;
      if(actNow){
        let keyword = this.$route.query.keyword;
        this.search(keyword);
      }
    },
    methods:{
      getLikeWord(){
        let seft = this;
        this.jsonp(this.https.getLikeWord+window.encodeURI(seft.keyword),'',function(error,response){
          if(seft.keyword!=''){
            seft.findLikeWord = true;
            seft.likeWords = response.result.map(function(item,index,array){
              return item[0];
            });
          }else{
            seft.findLikeWord = false;
            seft.likeWords = [];
          }
        })
      },
      search(key){
        if(this.histories.indexOf(key)<= -1){
          this.histories.unshift(key);
        }
        window.localStorage.setItem("history",JSON.stringify(this.histories));
        this.public.pageNumParam = '';
        this.jumpToView(this.headType.searchResultHead,"k="+key,key)
      },
      clearHistory(){
        this.histories = [];
        window.localStorage.removeItem("history");
      },
      showK(k){
        let key = this.keyword;
        let start = k.indexOf(key);
        let end = start+key.length;
        if(start>-1){
          return k.slice(0,start)+'<b style="color: #000000">'+key+'</b>'+ k.slice(end+1)
        }else{
          return k;
        }
      },
      setCookie(key, value, day) {
        let date = new Date();
        date.setDate(date.getDate() + day);
        document.cookie = key + '=' + encodeURI(value) + ';expires=' + date;
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// Search.vue?0a96bb80